import { render, staticRenderFns } from "./CustomerAddedFrom.vue?vue&type=template&id=30c1ff63&"
import script from "./CustomerAddedFrom.vue?vue&type=script&lang=ts&"
export * from "./CustomerAddedFrom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports